import * as React from 'react'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import type { LeaveSummary } from '../utils/leaveSummary'


const YearlyLeaveCounters = ({ summary }: { summary: LeaveSummary }) => {
  const { t } = useLocalize()

  const formatValue = ({ used, limit, limitUnknown }: LeaveSummary[number]) => {
    if (limitUnknown) return `${used}/?`
    return limit === null ? `${used}` : `${used}/${limit}`
  }

  return (
    <div className="tw-flex tw-flex-wrap tw-items-center tw-gap-x-3 tw-gap-y-0.5 tw-text-[11px] tw-leading-tight tw-text-gray-500">
      {summary.map((counter) => (
        <span key={counter.key} className="tw-whitespace-nowrap">
          {t(`driverModule.leave-summary-${counter.key}`)}:{' '}
          <span className="tw-font-medium tw-text-gray-700">
            {formatValue(counter)}
          </span>
        </span>
      ))}
    </div>
  )
}

export default YearlyLeaveCounters
